import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Pagination as Pagination$1 } from '@mui/material';
import { Stack } from '@mui/system';
import { useIsMobile } from '../../hooks/use-is-mobile.js';
import '@mui/material/styles';
import '../../foundation/utils.js';
import { SelectPageSize } from './select-page-size.js';

const Pagination = props => {
  const isMobile = useIsMobile();
  const {
    page,
    pageSize,
    lastPage,
    onChangePage,
    onChangePageSize
  } = props;
  return jsxs(Stack, Object.assign({
    flexDirection: ['column-reverse', 'row'],
    justifyContent: "flex-end",
    alignItems: ['end', 'center'],
    gap: 4
  }, props, {
    children: [jsx(SelectPageSize, {
      pageSize: pageSize,
      onChangePageSize: onChangePageSize,
      onChangePage: onChangePage
    }), jsx(Pagination$1, {
      count: lastPage,
      page: page,
      onChange: (_, page) => onChangePage(page),
      variant: "outlined",
      shape: "rounded",
      siblingCount: isMobile ? 0 : undefined,
      boundaryCount: isMobile ? 1 : undefined
    })]
  }));
};

export { Pagination };
